import { Row } from 'react-table';
import { GenericTableConfigViewEntry } from '../../dto';
import { FormattedMessage } from 'react-intl';

export const DataSourceFileColumnCell = ({ row }: { row: Row<GenericTableConfigViewEntry> }) => {
    if (row.values.dataSourceFileName) {
        return row.values.dataSourceFileName;
    }

    return (
        <FormattedMessage
            id="inside-fifa.generic-tables.data-source-file-by-id"
            values={{
                id: row.original.dataSource.fileId ?? (
                    <FormattedMessage id="inside-fifa.generic-tables-data-source-file-unknown" />
                ),
            }}
        />
    );
};
